import React, { useState, useCallback } from 'react';

import useAuth from 'hooks/useAuth';

import { Title } from 'components/Text';
import { Row, Col } from 'components/layout';

import ChangePasswordForm from '../components/ChangePasswordForm'

const ProfileTab = ({ showMessage }) => {
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = useCallback(({ currentPassword, newPassword }) => {
    setIsLoading(true);
    
    auth.actions.changePassword({ currentPassword, password: newPassword })
      .then(() => {
        showMessage('success', 'Your password has been changed!');
      })
      .catch(err => {
        console.log(err);
        if (err.code === "NotAuthorizedException") {
          showMessage('error', 'Your current password is incorrect');
        } else {
          showMessage('error', 'Password change failed. Please try again later!');
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [auth.actions, showMessage, setIsLoading]);

  return (
    <Row justify="center">
      <Col>
        <Title
          level={4}
          style={{
            textAlign: 'center',
            marginBottom: '32px'
          }}
        >
          Change Password
        </Title>
        <ChangePasswordForm  onSubmit={onSubmit} isLoading={isLoading}/>
      </Col>
    </Row>
  );
};

export default ProfileTab;
